// moved to Proteus 

const FavoriteDropdown4i = function () {
    let loading,
        contentTemplate = document.querySelector(".favDropdownTemplate").innerHTML,
        inertTargets = [],

        init = () => {
            document.getElementById("mainContent").addEventListener("click", events);
        },

        events = (e) => {
            if (e.target.classList.contains("faveLink")) {
                e.preventDefault();
                toggle(e.target);
            } else if (e.target.classList.contains("cancel-delete-item")) {
                e.preventDefault();
                removeMsg();
                document.querySelector('.ideaBoardList').querySelector("button").focus();
            } else if (e.target.classList.contains("confirm-delete-item")) {
                e.preventDefault();
                deleteTheItem(e.target);
            } else if (e.target.classList.contains("boardName")) {
                e.preventDefault();
                addToExistingBoard(e.target);
            } else if (e.target.classList.contains("closeFavorites")) {
                e.preventDefault();
                closeRemove(true);
            }
        },

        removeMsg = () => {
            const msg = document.querySelector(".addToBoardMsg");
            if (msg) msg.remove();
        },

        deleteTheItem = async (el) => {
            let [boardID, boardItemID] = el.getAttribute('href').split('/');
            loading = el.closest('.ideaBoardList').querySelector('.addItemLoading');
            loading.classList.remove("hide");

            let responseJSON;
            const data = { boardID, boardItemID };

            try {
                const response = await fetch('/favs/deleteboarditem', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'fetch'
                    }
                });
                responseJSON = await response.json();
            } catch (error) {
                console.log(error);
            }

            if (responseJSON) deletedFromBoard(responseJSON, el);
        },

        keyEvents = (e) => {
            if ((e.which || e.keyCode) === 27) closeRemove(true); // Escape key
        },

        toggle = (heartIcon) => {
            if (heartIcon.nextElementSibling && heartIcon.nextElementSibling.classList.contains("ideaBoardList")) {
                closeRemove(true);
            } else {
                open(heartIcon);
            }
        },

        open = (heartIcon) => {
            closeRemove(false);

            heartIcon.insertAdjacentHTML('afterend', contentTemplate);
            heartIcon.setAttribute("aria-expanded", "true");

            let boardDropDown = heartIcon.nextElementSibling;
            boardDropDown.removeEventListener('keydown', keyEvents);
            boardDropDown.addEventListener('keydown', keyEvents);

            // Set ARIA dialog properties
            boardDropDown.setAttribute("role", "dialog");
            boardDropDown.setAttribute("aria-modal", "true");
            boardDropDown.classList.remove("hide");
            boardDropDown.setAttribute("tabindex", "0");
            boardDropDown.removeAttribute("inert");
            boardDropDown.removeAttribute("aria-hidden");

            // Inert everything except modal and its ancestors
            const modalAncestors = new Set();
            let current = boardDropDown;
            while (current) {
                modalAncestors.add(current);
                current = current.parentElement;
            }

            inertTargets = Array.from(document.body.children).filter(el => !modalAncestors.has(el));
            inertTargets.forEach(el => {
                el.setAttribute("inert", "");
                el.setAttribute("aria-hidden", "true");
            });

            // Focus first interactive element
            const focusTarget = boardDropDown.querySelector("button, a");
            if (focusTarget) focusTarget.focus();

            // Trap keyboard focus inside the modal
            trapFocus(boardDropDown);

            // Update product name
            let prodName = heartIcon.querySelector(".prodNameFavsBoard")?.innerHTML;
            let existingBoards = boardDropDown.querySelectorAll(".addToBoardProdName");
            for (let i = 0; i < existingBoards.length; i++) {
                existingBoards[i].innerHTML = prodName;
            }
        },

        closeRemove = (setFocus) => {
            let dropdown = document.querySelector(".ideaBoardList");
            if (!dropdown) return;

            if (!dropdown.parentNode.classList.contains("favDropdownTemplate")) {
                let heartIcon = dropdown.previousElementSibling;
                heartIcon.setAttribute("aria-expanded", "false");

                dropdown.classList.add("hide");
                dropdown.setAttribute("tabindex", "-1");
                dropdown.setAttribute("inert", "");
                dropdown.setAttribute("aria-hidden", "true");

                inertTargets.forEach(el => {
                    el.removeAttribute("inert");
                    el.removeAttribute("aria-hidden");
                });
                inertTargets = [];

                dropdown.remove();
                if (setFocus) heartIcon.focus();
            }
        },

        addToExistingBoard = async (boardName) => {
            loading = boardName.closest('.ideaBoardList').querySelector('.addItemLoading');
            let boardIDNumber = boardName.parentNode.querySelector('.board-id').value;
            let productID = (typeof prodID === 'undefined') ? boardName.closest('.faveLinkWrapper').parentNode.querySelector('.faveLinkProdID').value : prodID;
            if (productID == null) productID = document.getElementById('productid').value;

            removeMsg();
            loading.classList.remove("hide");

            let responseJSON;
            const data = { boardID: boardIDNumber, productID };

            try {
                const response = await fetch('/favs/additemtoboard', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'fetch'
                    }
                });
                responseJSON = await response.json();
            } catch (error) {
                console.log(error);
            }

            if (responseJSON) addedToBoard(responseJSON, boardName);
        },

        turnFavOn = (heartIcon) => {
            heartIcon.classList.remove("textLtGray");
            heartIcon.classList.add("textRed");
        },

        turnFavOff = (heartIcon) => {
            heartIcon.classList.remove("textRed");
            heartIcon.classList.add("textLtGray");
        },

        addedToBoard = (response, el) => {
            loading.classList.add("hide");
            if (response.success == "true") {
                let heartIcon = el.closest('.faveLinkWrapper').querySelector('.faveLink');
                turnFavOn(heartIcon);
                el.insertAdjacentHTML('afterend', response.message);
                el.nextElementSibling.querySelector("a").focus();
            }
        },

        deletedFromBoard = (response, el) => {
            loading.classList.add("hide");
            if (response.isItemInOtherBoards == "False") {
                let heartIcon = el.closest('.faveLinkWrapper').querySelector('.faveLink');
                turnFavOff(heartIcon);
            }
            removeMsg();
            document.querySelector('.ideaBoardList').querySelector("button").focus();
        },

        trapFocus = (modal) => {
            const focusable = modal.querySelectorAll(
                'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
            );
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            modal.addEventListener('keydown', function (e) {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        if (document.activeElement === first) {
                            e.preventDefault();
                            last.focus();
                        }
                    } else {
                        if (document.activeElement === last) {
                            e.preventDefault();
                            first.focus();
                        }
                    }
                }
            });
        };

    return {
        Init: init
    };
};

(function () {
    const favoriteDropDown = new FavoriteDropdown4i();
    favoriteDropDown.Init();
})();